import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20dramatic%20background%20with%20deep%20emerald%20green%20and%20black%20tones%20layered%20textures%20smoky%20atmosphere%20cinematic%20lighting%20mysterious%20vibe%20editorial%20photography%20style%20rich%20contrast%20dark%20gradient%20overlay%20sophisticated%20noir%20aesthetic&width=1800&height=1200&seq=hero-bg-911&orientation=landscape"
        alt="911爆料网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-start justify-center px-4 md:px-6 lg:px-10">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading text-white leading-tight mb-6">
            网红黑料<br />明星八卦<br />每日实时更新
          </h1>
          <p className="text-white/80 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
            911爆料网聚合全网网红黑料、明星塌房现场、社会热点事件，吃瓜群众专属爆料平台，最新大瓜一手掌握。
          </p>
          <Link
            to="/category/wanghong-heiliao"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500/85 backdrop-blur-sm text-white font-medium text-sm rounded-full hover:bg-primary-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 pb-8 md:pb-12 px-4 md:px-6 lg:px-10">
        <p className="text-white text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-heading font-bold leading-none tracking-tighter opacity-40 select-none">
          吃瓜前线·每日爆料
        </p>
      </div>
    </section>
  );
}